import { FunctionComponent } from 'react';
import { useBoardingRates } from './BoardingRatesProvider';
import RatesContent from './List/RatesContent';
import RatesIsEmpty from './List/RatesIsEmpty';
import RateForm from './Form/RateForm';
import Spinner from 'components/UI/V3/Spinner';
import styles from './BoardingRatesContent.module.scss';

const BoardingRatesContent: FunctionComponent = () => {
    const {
        isFirstRender,
        isTrueEmpty,
        areServicesLoading,
        showForm,
        selectedRate,
        editServiceId,
        openAddForm,
        closeForm
    } = useBoardingRates();

    if (isFirstRender || areServicesLoading) {
        return (
            <div className={styles.loadingContainer}>
                <Spinner />
            </div>
        );
    }

    return (
        <div className={styles.container}>
            {isTrueEmpty ? (
                <RatesIsEmpty
                    title="Rates"
                    text='Click the "Add Rate" button to add your first one'
                    showButton={true}
                    onClick={openAddForm}
                />
            ) : (
                <RatesContent onAdd={openAddForm} />
            )}
            {showForm && (
                <RateForm
                    rate={selectedRate}
                    serviceId={editServiceId ?? undefined}
                    onClose={closeForm}
                />
            )}
        </div>
    );
};

export default BoardingRatesContent;
